import { t } from 'components/translation/Translation';

export const hearOptions = [
  {
    display: 'Google',
    id: 'google',
    name: 'how_did_you_hear',
    value: 'Google',
  },
  {
    display: 'Facebook',
    id: 'facebook',
    name: 'how_did_you_hear',
    value: 'Facebook',
  },
  {
    display: t('onboarding:onboarding.arizona_federation'),
    id: 'arizona federation',
    name: 'how_did_you_hear',
    value: 'Arizona Federation For Children Powered by Schola®',
  },
  {
    display: t('onboarding:onboarding.other'),
    id: 'other',
    name: 'how_did_you_hear',
    value: 'Other',
  },
];
